import React, { Component } from 'react';
import { components } from 'react-select';

const SingleValue = ({ children, ...props }) => {

    const placeholder = () => {
        if(props.selectProps.selected) {
            if(props.selectProps.selectedAllChecked) {
                return props.selectProps.placeholder
            } else {
                var count = (
                    props.selectProps.options.length > 0
                        ? props.selectProps.options
                        : props.selectProps.selectedOptions
                ).filter((item, key) => {
                    return item.checked == true
                }).length
                return count ? `${count} Selections` : props.selectProps.placeholder
            }
        } else {
            return props.selectProps.placeholder
        }
    }

    return (
        <components.SingleValue {...props}>{placeholder()}</components.SingleValue>
    );
};

export default SingleValue;